import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCaretLeft = () => {
  return (
    <g>
      <path d="m11.45 1.7437c0-.605-.35-.75-.7778-.3222l-5.801 5.8007a1.1032 1.1032 0 0 0 0 1.5556l5.8006 5.8006c.4278.4278.7778.2828.7778-.3222z" />
    </g>
  );
};

export default withIcon(IconCaretLeft);
